//export const SUCCESS_URL = 'http://localhost:3000/dashboard';
//export const CANCEL_URL = 'http://localhost:3000/dashboard';
// export const SUCCESS_URL = 'https://word-galaxy-8f9c5.web.app/settings';
// export const CANCEL_URL = 'https://word-galaxy-8f9c5.web.app/dashboard';
export const SUCCESS_URL = 'https://wordgalaxy.ai/settings';
export const CANCEL_URL = 'https://wordgalaxy.ai/dashboard';
// export const STRIPE_PUBLIC_KEY = 'pk_test_51N85BvARii4e5Kcb6K7Oylilvgac8rk2YJnsGHGh3Oq3og6lMY9jvj7tTOZjyozhkT5Ocuh1RlDpG7SagYViQL9d003NpesnIA';
export const STRIPE_PUBLIC_KEY = 'pk_live_51N85BvARii4e5KcbJdD45CDlJmVNGy3wNVS1RiiwDYcXNwwabZ6XR6h15ryZmlxSvHR4moFMd85wSrw2hNV69JiA00pOczojIX';
// export const CANCEL_SUBSCRIPTION_URL = ''
export const STRIPE_PORTAL_URL = 'https://billing.stripe.com/p/login/eVacQL8G1dCVbPGaEE'